import { type TGroup } from '../store';

/** Globally-registered groups, keyed by key. Higher priority sorts first within a mode depth. */
export const SPOTLIGHT_GROUPS: Record<string, TGroup> = {
  navigation: { key: 'navigation', label: 'Navigation', priority: 20 },
  settings: { key: 'settings', label: 'Opal Settings', priority: 10 },
  theme: { key: 'theme', label: 'Theme', priority: 0 },
};
